import * as React from 'react'
import { useCallback } from 'react'
import {
  IOption,
  iOptionEqualityComparer,
  IPropsWithProvider,
  OptionDependency,
  SingleSelect,
} from '../../typings'

import AutoComplete, {
  AutocompleteChangeReason,
} from '@mui/material/Autocomplete'
import Chip from '@mui/material/Chip'
import { AutoCompleteInput } from '@sales-center/components'

interface Props extends IPropsWithProvider {
  value: SingleSelect
  setValue: (value: SingleSelect) => void
  dependsOn?: OptionDependency
}

export const SingleSelectAutoComplete: React.FC<Props> = ({
  value,
  setValue,
  dependsOn,
  component: Component,
}) => {
  const onChangeHandler = useCallback(
    (
      _e: React.ChangeEvent<unknown>,
      value: IOption,
      _reason: AutocompleteChangeReason,
    ) => setValue(value),
    [setValue],
  )

  return (
    <Component
      dependsOn={dependsOn}
      render={(options, loading) => (
        <AutoComplete
          loading={loading}
          disabled={loading}
          options={options}
          onChange={onChangeHandler}
          value={value}
          filterSelectedOptions
          getOptionDisabled={(o: IOption) => o.disabled ?? false}
          getOptionLabel={(o: IOption) => o.label}
          renderOption={(props, o: IOption) => {
            return (
              <li {...props}>
                {!o.alternativeLabel ? o.label : o.alternativeLabel}
              </li>
            )
          }}
          isOptionEqualToValue={iOptionEqualityComparer}
          renderInput={(params) => (
            <AutoCompleteInput loading={loading} {...params} />
          )}
          renderTags={(value: IOption[], getTagProps) =>
            value.map((v, index) => (
              <Chip
                {...getTagProps({ index })}
                key={index}
                label={v.label}
                color="primary"
              />
            ))
          }
        />
      )}
    />
  )
}
SingleSelectAutoComplete.displayName = 'SingleSelectAutoComplete'
